import React, { useState } from 'react';
import intakeConfig from '../../data/skinAnalysisIntake.json';
import './skinAnalysis.css';

// Short, optional questionnaire shown before the capture wizard. Mirrors the
// JSON-driven approach used by the quiz. Answers feed the analyzer and the
// tanning opt-in toggles tanning-content recommendations.
function defaultAnswers() {
  const a = {};
  intakeConfig.questions.forEach((q) => {
    if (q.type === 'toggle') a[q.id] = q.default !== false;
    else if (q.type === 'multi') a[q.id] = [];
    else a[q.id] = null;
  });
  return a;
}

const Intake = ({ onComplete }) => {
  const [answers, setAnswers] = useState(defaultAnswers);

  const setSingle = (qid, oid) => setAnswers((p) => ({ ...p, [qid]: oid }));
  const setToggle = (qid) => setAnswers((p) => ({ ...p, [qid]: !p[qid] }));
  const toggleMulti = (q, oid) =>
    setAnswers((p) => {
      const cur = p[q.id] || [];
      if (cur.includes(oid)) return { ...p, [q.id]: cur.filter((x) => x !== oid) };
      if (q.maxSelect && cur.length >= q.maxSelect) return p;
      return { ...p, [q.id]: [...cur, oid] };
    });

  return (
    <div className="skin-intake">
      <h1 className="skin-intake__title">{intakeConfig.title}</h1>
      {intakeConfig.subtitle && <p className="skin-intake__subtitle">{intakeConfig.subtitle}</p>}

      {intakeConfig.questions.map((q) => (
        <div className="skin-intake__q" key={q.id}>
          <div className="skin-intake__q-label">{q.label}</div>

          {q.type === 'toggle' ? (
            <button
              type="button"
              className={`skin-chip${answers[q.id] ? ' is-selected' : ''}`}
              onClick={() => setToggle(q.id)}
            >
              {answers[q.id] ? 'Yes' : 'No'}
            </button>
          ) : (
            <div className="skin-intake__options">
              {q.options.map((o) => {
                const selected = q.type === 'multi'
                  ? (answers[q.id] || []).includes(o.id)
                  : answers[q.id] === o.id;
                return (
                  <button
                    type="button"
                    key={o.id}
                    className={`skin-chip${selected ? ' is-selected' : ''}`}
                    onClick={() => (q.type === 'multi' ? toggleMulti(q, o.id) : setSingle(q.id, o.id))}
                  >
                    {o.label}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      ))}

      <button type="button" className="skin-btn skin-btn--primary" onClick={() => onComplete(answers)}>
        Start analysis
      </button>
    </div>
  );
};

export default Intake;
